import React from 'react'
import { GlobalStyle } from '@welcom/esg-react-components'
import { WithAppContext } from './appState'
import { AppWrapper } from './components/AppWrapper'
import { ApolloProvider } from '@apollo/client'
import client from './apolloClient'

import './App.css'
import { Steps } from './components/Steps'

function App() {
   return (
      <div className="App">
         <GlobalStyle />
         <WithAppContext>
            <ApolloProvider client={client}>
               <AppWrapper>
                  <Steps />
               </AppWrapper>
            </ApolloProvider>
         </WithAppContext>
      </div>
   )
}

export default App
